import styled from '@emotion/styled';

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const LabelHead = styled.label`
  font-size: 14px;
  color: #333;
`;

const LabelBody = styled.label`
  width: 300px;
  height: 36px;
  padding: 8px 3px;
  font-size: 14px;
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    border-color: #666;
  }
`;

export function LoginLabelField({ id, head, body }: { id: string; head: string; body: string }) {
  return (
    <LabelWrapper id={id}>
      <LabelHead>{head}</LabelHead>
      <LabelBody>{body}</LabelBody>
    </LabelWrapper>
  );
}
